import axios from 'axios';
import { AuditLogDetailsDto, FilteredAuditLogsResponse } from '../models/auditLog.model';

function ensureBaseUrl() {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}

export interface AuditLogsListFilters {
    entityName?: string;
    primaryKey?: number;
    startDate?: string;
    endDate?: string;
    userId?: number;
    employeeId?: number;
    operation?: number;
    correlationId?: string;
    offset: number;
    top: number;
    orderBy: string;
    ascending: boolean;
    searchTerm: string;
}

function appendIf(
    q: URLSearchParams,
    key: string,
    value: string | number | null | undefined
) {
    if (value === null || value === undefined || value === '') {
        return;
    }
    q.set(key, String(value));
}

export function buildAuditLogsListQuery(params: AuditLogsListFilters): string {
    const q = new URLSearchParams();
    appendIf(q, 'entityName', params.entityName?.trim());
    if (params.primaryKey != null && !Number.isNaN(params.primaryKey)) {
        q.set('primaryKey', String(params.primaryKey));
    }
    appendIf(q, 'startDate', params.startDate);
    appendIf(q, 'endDate', params.endDate);
    if (params.userId != null && !Number.isNaN(params.userId)) {
        q.set('userId', String(params.userId));
    }
    if (params.employeeId != null && !Number.isNaN(params.employeeId)) {
        q.set('employeeId', String(params.employeeId));
    }
    if (params.operation !== undefined && params.operation !== null && !Number.isNaN(params.operation)) {
        q.set('operation', String(params.operation));
    }
    appendIf(q, 'correlationId', params.correlationId?.trim());
    q.set('offset', String(params.offset));
    q.set('top', String(params.top));
    q.set('orderBy', params.orderBy);
    q.set('ascending', String(params.ascending));
    q.set('searchTerm', params.searchTerm ?? '');
    return `/jerusalem/api/v1/audit-logs?${q.toString()}`;
}

export async function fetchAuditLogsList(
    params: AuditLogsListFilters
): Promise<FilteredAuditLogsResponse> {
    ensureBaseUrl();
    const url = buildAuditLogsListQuery(params);
    const { data } = await axios.get<FilteredAuditLogsResponse>(url);
    return data;
}

export type AuditLogDetailResult =
    | { ok: true; data: AuditLogDetailsDto }
    | { ok: false; status: 404 | 403 | 'other'; message?: string };

export async function fetchAuditLogById(id: number): Promise<AuditLogDetailResult> {
    ensureBaseUrl();
    try {
        const { data } = await axios.get<AuditLogDetailsDto>(
            `/jerusalem/api/v1/audit-logs/${id}`
        );
        return { ok: true, data };
    } catch (e: unknown) {
        const err = e as { response?: { status?: number; data?: unknown } };
        const status = err.response?.status;
        const message =
            typeof err.response?.data === 'string'
                ? err.response.data
                : (err.response?.data as { message?: string })?.message;
        if (status === 404) {
            return { ok: false, status: 404 };
        }
        if (status === 403) {
            return { ok: false, status: 403, message };
        }
        return { ok: false, status: 'other', message: message || 'Error al cargar auditoría' };
    }
}
